import type { PortfolioNavLink } from './PortfolioNav'

type UtilityProductKey =
  | 'pdfy'
  | 'txtify'
  | 'devdeck'
  | 'dateify'
  | 'imgify'
  | 'qrka'
  | 'calcdeck'
  | 'fileify'
  | 'mediatik'

const PORTFOLIO_PRODUCTS: Array<Omit<PortfolioNavLink, 'current'>> = [
  { key: 'pdfy', label: 'PDF', href: 'https://pdfy.ru/' },
  { key: 'txtify', label: 'Текст', href: 'https://txtify.ru/' },
  { key: 'devdeck', label: 'Код', href: 'https://devdeck.ru/' },
  { key: 'dateify', label: 'Даты', href: 'https://dateify.ru/' },
  { key: 'imgify', label: 'Фото', href: 'https://imgify.ru/' },
  { key: 'qrka', label: 'QR', href: 'https://qrka.ru/' },
  { key: 'calcdeck', label: 'Расчёты', href: 'https://calcdeck.ru/' },
  { key: 'fileify', label: 'Файлы', href: 'https://fileify.ru/' },
  { key: 'mediatik', label: 'Медиа', href: 'https://mediatik.ru/' },
]

export function buildPortfolioProducts(current: UtilityProductKey): PortfolioNavLink[] {
  return PORTFOLIO_PRODUCTS.map((product) => ({
    ...product,
    current: product.key === current,
  }))
}
